import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Upload } from '../../services/upload/upload';

import { ProductClientService, PrClientData } from '../../services/product-client.service';
import { Subscription } from 'rxjs';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-display-pr-client',
  templateUrl: './display-pr-client.component.html',
  styleUrls: ['./display-pr-client.component.css']
})
export class DisplayPrClientComponent implements OnInit, OnDestroy {
  permission: any = {};

  prClient: any = undefined;

  image: any = {width: 1, height: 0};

  currentImageIndex: number;
  modalActionsImage = new EventEmitter<string|MaterializeAction>();
  modalParamsImage = [{dismissible: true}];

  prClientForm: FormGroup;

  codeGivenByVal: string;
  code: string;
  isLineProduct: boolean;
  isLastVersion: boolean;

  sections = [];

  generalActivities: any[] = [];

  currentSectionTab: number;
  currentSectionShowing: boolean;

  prClientId: string;

  quotationsData = {};

  sub: Subscription;

  constructor(
    private fb: FormBuilder,
    private service: ProductClientService,
    private prClientData: PrClientData,
    private settings: CatalogsSettingsService,
    private authService: AuthService,
    private permissionService: PermissionService,
    private activatedRoute: ActivatedRoute
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
    });

    this.prClientId = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    this.sub = this.service.getPrClient(this.prClientId).subscribe(([{companyObj, ...prClient}]) => {
      this.prClient = {
        companyImageURL: companyObj.imageURL,
        companyName: companyObj.name,
        ...prClient
      };
      this.prClientForm.patchValue(prClient);
      if(prClient.packaging){
        this.prClientForm.get('wide').patchValue(prClient.packaging.wide);
        this.prClientForm.get('long').patchValue(prClient.packaging.long);
        this.prClientForm.get('height').patchValue(prClient.packaging.height);
        this.prClientForm.get('pasteType').patchValue((this.prClientData.pasteTypeSelect[prClient.pasteType] || {})['name'] || '');
      }
      this.prClientForm.get('customerName').patchValue(prClient.customerObj.name);
      this.prClientForm.get('employeeName').patchValue(`${prClient.employeeObj.name} ${prClient.employeeObj.lastName}`);
      this.prClientForm.get('prVntaName').patchValue(prClient.prVntaObj.name);
      this.prClientForm.get('quotationFolio').patchValue(prClient.quotObj ? prClient.quotObj.folio : '');

      this.codeGivenByVal = prClient.codeGivenBy;
      this.code = prClient.code;
      this.isLineProduct = prClient.isLineProduct;
      this.isLastVersion = prClient.isLastVersion;
      this.sections = prClient.sections.map(({inks: {front, back}, activities, ...section}) => ({
        ...section,
        frontInk: front.reduce((acc, cur, index) => acc + (index && cur ? ', ' : '') + cur, ''),
        backInk: back.reduce((acc, cur, index) => acc + (index && cur ? ', ' : '') + cur, ''),
        activities: activities.map(activity => {
          if(!activity.unique) activity.unique = {};
          if(activity.unique && activity.unique.pasteType){
            activity.unique.pasteType = this.prClientData.pasteTypeSelect[activity.unique.pasteType || '6'].name;
          }
          return activity;
        })
      }) );
      this.generalActivities = prClient.generalActivities.map(activity => {
          if(activity.unique && activity.unique.pasteType){
            activity.unique.pasteType = this.prClientData.pasteTypeSelect[activity.unique.pasteType || '6'].name;
          }
          return activity;
        }) || [];

      let setSub = this.settings.getPayrollSettings('1').subscribe(({isoDescriptions: {FichT, EspT}}) => {
        setSub.unsubscribe();
        [ this.prClient.isoDescriptionFicha, this.prClient.isoDescriptionEspecificacion ] = [FichT, EspT];
      })
    })
  }
  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  createForm(){
    this.prClientForm = this.fb.group({
      customerName: ['', Validators.required],
      employeeName: ['', Validators.required],
      prVntaName: ['', Validators.required],
      code: ['', Validators.required],
      version: ['', Validators.required],
      barCode: '',
      designStatus: '',
      designComments: '',
      qualityStatus: '',
      qualityComments: '',
      shortDescription: '',
      longDescription: '',
      processOwnerComments: '',
      newVersionMotive: '',
      quotationFolio: '',
      //new
      IDPln: '',
      agreedPrice: '',
      characteristics: '',
      agreedDate: '',
      wide: '',
      long: '',
      height: '',
      valid: '',
      pasteType: '',
      flatNumber: '',
    });
  }

  openModalImage(url: string, index: number) {
    this.image = new Image();
    this.image.src = url;
    this.currentImageIndex = index;
    this.modalActionsImage.emit({ action: 'modal', params: ['open'] });
  }
  closeModalImage() {
    this.modalActionsImage.emit({ action: 'modal', params: ['close'] });
  }

  uploadFile(event,index) {
    var selectedFile: File = event.target.files[0];
    var currentUpload: Upload = new Upload(selectedFile);
    this.service.uploadFile(currentUpload, this.prClient, index);
  }

  deleteFile(index){
    this.service.deleteFile(this.prClient, index);
    this.closeModalImage();
  }

  changeSectionTab(index) {
    if(this.currentSectionTab == index) this.currentSectionShowing = !this.currentSectionShowing;
    else{
      this.currentSectionTab = index;
      this.currentSectionShowing = true;
    }
  }

  onEdit(){
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    this.service.windowReplace('edit', this.prClientId);
  }

  onPdf({isFicha}){
    //if(1) return toast('No está listo este servicio.');
    window[ isFicha ? 'sendPrClientToPhp' : 'sendPrClientEspecificacionToPhp' ](false);
  }

  get pdfJson(){
    return this.prClient ? JSON.stringify({
      customerName: this.prClient.customerObj.name,
      employeeName: `${this.prClient.employeeObj.name} ${this.prClient.employeeObj.lastName}`,
      prVntaName: this.prClient.prVntaObj.name,
      code: this.prClient.code,
      version: this.prClient.version,
      barCode: this.prClient.barCode,
      designStatus: this.prClient.designStatus,
      designComments: this.prClient.designComments,
      qualityStatus: this.prClient.qualityStatus,
      qualityComments: this.prClient.qualityComments,
      shortDescription: this.prClient.shortDescription,
      longDescription: this.prClient.longDescription,
      processOwnerComments: this.prClient.processOwnerComments,
      newVersionMotive: this.prClient.newVersionMotive,
      quotationFolio: this.prClient.quotObj ? this.prClient.quotObj.folio : '',

      IDPln: this.prClient.IDPln,
      agreedPrice: this.prClient.agreedPrice,
      characteristics: this.prClient.characteristics,
      agreedDate: this.prClient.agreedDate,
      packaging: this.prClient.packaging,
      valid: this.prClient.valid,
      pasteType: this.prClient.pasteType,
      flatNumber: this.prClient.flatNumber,
      
      quotFolio: (this.prClient.quotObj || {}).folio || '',

      sections: this.sections,
      generalActivities: this.generalActivities,

      companyImgUrl: this.prClient.companyImageURL,
      companyName: this.prClient.companyName,

      isoDescriptionFicha: this.prClient.isoDescriptionFicha,
      isoDescriptionEspecificacion: this.prClient.isoDescriptionEspecificacion

    }) : '';
  }

}
